import { useEffect, useState } from 'react'

import useWindowSize from './useWindowSize'

function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(false)
  const windowSize = useWindowSize()

  useEffect(() => {
    const handler = () => {
      setIsMobile(windowSize.width < 768)
    }

    // Set size at the first client-side load
    handler()

    window.addEventListener('resize', handler)

    return () => {
      window.removeEventListener('resize', handler)
    }
  }, [windowSize.width])

  return isMobile
}

export default useIsMobile
